import { useState, type FormEvent } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from './use-auth';
import { InstitutionLogo, useInstitutionBrand } from '../../components/institution-brand';

export function LoginPage() {
  const { login, status } = useAuth();
  const navigate = useNavigate();

  const [loginInput, setLoginInput] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { nama_pesantren } = useInstitutionBrand();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);

    try {
      await login({ login: loginInput.trim(), password });
      navigate('/dashboard', { replace: true });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Login gagal. Silakan coba lagi.';
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (status === 'authenticated') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
    >
      <section
        style={{
          width: '100%',
          maxWidth: '400px',
          border: '1px solid #e5e7eb',
          borderRadius: '0.5rem',
          padding: '2rem',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ display: 'grid', placeItems: 'center', marginBottom: '0.75rem' }}>
          <InstitutionLogo size={64} />
        </div>
        <h1 style={{ textAlign: 'center', marginBottom: '0.5rem' }}>{nama_pesantren}</h1>
        <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: '1.5rem' }}>
          Masuk ke sistem
        </p>

        {error && (
          <div
            role="alert"
            style={{
              marginBottom: '1rem',
              padding: '0.75rem',
              borderRadius: '0.375rem',
              backgroundColor: '#fee2e2',
              color: '#991b1b',
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="login" style={{ display: 'block', marginBottom: '0.25rem' }}>
              Username atau Email
            </label>
            <input
              id="login"
              name="login"
              type="text"
              autoComplete="username"
              required
              minLength={3}
              maxLength={254}
              value={loginInput}
              onChange={(e) => setLoginInput(e.target.value)}
              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.375rem',
              }}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label htmlFor="password" style={{ display: 'block', marginBottom: '0.25rem' }}>
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              minLength={8}
              maxLength={128}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.375rem',
              }}
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting || status === 'loading'}
            style={{
              width: '100%',
              padding: '0.75rem',
              border: 'none',
              borderRadius: '0.375rem',
              backgroundColor: '#2563eb',
              color: '#ffffff',
              cursor: 'pointer',
              fontWeight: 600,
              opacity: isSubmitting || status === 'loading' ? 0.7 : 1,
              marginBottom: '1rem',
            }}
          >
            {isSubmitting || status === 'loading' ? 'Memuat...' : 'Masuk'}
          </button>
        </form>

        <div style={{ textAlign: 'center' }}>
          <Link
            to="/register"
            style={{
              display: 'inline-block',
              width: '100%',
              padding: '0.75rem',
              border: '1px solid #d1d5db',
              borderRadius: '0.375rem',
              backgroundColor: '#f9fafb',
              color: '#374151',
              textAlign: 'center',
              textDecoration: 'none',
              fontWeight: 600,
              boxSizing: 'border-box',
            }}
          >
            Daftar Akun
          </Link>
        </div>
      </section>
    </main>
  );
}
